module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/checkGreen.16cab7b2.svg";